import React from 'react';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="loading-spinner">
      <div className="nisa-spinner">
        <div className="nisa-spinner-ring"></div>
        <div className="nisa-spinner-ring"></div>
        <div className="nisa-spinner-ring"></div>
        <div className="nisa-spinner-icon">
          <i className="bi bi-heart-pulse-fill"></i>
        </div>
      </div>
      <div className="loading-text">{message}</div>
    </div>
  );
};

export default LoadingSpinner;